export default __webpack_public_path__ + "static/Autos2050-Award-315d907551017b515ee34e7c3235603b.png";